import { CoolHttp } from '@angular-cool/http';
import { Injectable } from '@angular/core';
import { HelpSiteDataDTO } from '../../../../../common/dto/help-site.dto';
import {
  KnowledgeBaseArticleDTOListing,
  KnowledgeBaseCategoryId,
  KnowledgeBaseFeaturedDTO,
} from '../../../../../common/dto/knowledge-base.dto';
import { Language } from '../../../../../common/dto/languages.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';

@Injectable()
export class HelpSiteService {
  constructor(private _http: CoolHttp) {
  }

  public async getHelpSiteDataAsync(language: Language): Promise<HelpSiteDataDTO> {
    return await this._http.getAsync(ServerUrls.HelpSite._.Data._.Get.absoluteUrl, {
      params: {
        [ServerUrls.HelpSite._.Data._.Get.queryParams.language]: language,
      },
    });
  }

  public async getArticlesOfCategoryAsync(categoryId: KnowledgeBaseCategoryId): Promise<KnowledgeBaseArticleDTOListing[]> {
    return await this._http.getAsync(ServerUrls.HelpSite._.Categories._.ById._.Articles.getAbsoluteUrlWithParams({
      [ServerUrls.HelpSite._.Categories._.ById.params.categoryId]: categoryId,
    }));
  }

  public async getArticleByLinkAsync(urlPart: string) {
    return await this._http.getAsync(ServerUrls.HelpSite._.Articles._.GetByPart.getAbsoluteUrlWithQuery({
      [ServerUrls.HelpSite._.Articles._.GetByPart.queryParams.part]: urlPart,
    }));
  }

  public async searchArticlesAsync(searchText: string): Promise<KnowledgeBaseArticleDTOListing[]> {
    return await this._http.getAsync(ServerUrls.HelpSite._.Articles._.Get.getAbsoluteUrlWithQuery({
      [ServerUrls.HelpSite._.Articles._.Get.queryParams.filter]: searchText,
    }));
  }

  public async getFeaturedAsync(): Promise<KnowledgeBaseFeaturedDTO[]> {
    return await this._http.getAsync(ServerUrls.HelpSite._.Featured._.Get.absoluteUrl);
  }
}
